<template>
  <!-- 头部整体盒子 -->
  <div
    id="header"
    class="container-fuild"
    v-if="$route.name == 'home' || $route.name == 'singlepage' || $route.name == 'search' || $route.name == 'showCoin' || $route.name == 'agentList' ||  $route.name == 'overseasAgency' || 
			$route.name == 'feedback' || $route.name == 'scoreCount' || $route.name == 'applyinvoice' || $route.name == 'article_list' || $route.name == 'article'"
  >
    <!-- 头部顶部 -->
    <div
      class="header-top container-fuild hidden-xs"
      style="position: relative;"
    >
      <div
        class="container"
        style="display: flex;align-items: center;"
      >
        <img
          src="../assets/img/gbLogo.png"
          alt=""
        >
        <div class="topSearchInputBox">
          <input
            type="text"
            v-model="ratingCode"
            @keydown.enter="handleSearch"
            class="input"
            :placeholder="$t('message.i18n_2')"
            style="color: #000000;padding-left: 10px;"
          >
          <span
            class="tip"
            @click="handleSearch"
          >{{ $t("message.i18n_1") }}</span>
        </div>
        <div class="serveTelBox visible-lg">
          <div class="top">{{ $t("message.i18n_4") }}</div>
          <div class="bot">(010)83559899</div>
        </div>
        <!-- 大屏幕时 右上角显示语言选择按钮 -->
        <div style="
							position: absolute;
							right: 30px;
							top: 0;
							line-height: 30px;
							display: flex;
							font-size: 12px;
							color: #666666;">
          <div
            style="cursor: pointer;"
            :style="{ color: $store.state.languageVuex == 'zh-CN' ? 'red' : '#666666' }"
            onmouseenter="this.style.background='#ffffff';this.style.opacity='0.8'"
            onmouseleave="this.style.background='none';this.style.opacity=1"
            @click="language = 'zh-CN'"
          >
            中文
          </div>
          <div style="margin: 0 6px;"> | </div>
          <div
            style="cursor: pointer;"
            :style="{color: $store.state.languageVuex == 'en' ? 'red' : '#666666' }"
            onmouseenter="this.style.background='#ffffff';this.style.opacity='0.8'"
            onmouseleave="this.style.background='none';this.style.opacity=1"
            @click="language = 'en'"
          >
            EN
          </div>
        </div>
      </div>
    </div>
    <!-- 电脑导航 -->
    <div
      class="header-nav hidden-xs"
      style="background-color: #E22434;"
      :class="{'navbar-fixed-top' : pcWrapperFix}"
    >
      <!-- 导航内容 -->
      <div class="container">
        <ul class="header-nav-wrapper ">
          <template v-for="(item,index) in menuList">
            <li
              v-if="item.title"
              :class="index==navIndex?'active':''"
              @click="navClick(index,item.title)"
              style="font-size: 16px;"
            >
              <router-link
                :to=" item.type == 1 ? ('/page/singlepage/' + item.id ): item.type == 'home' ? '/' : item.type == 4 ? item.url : item.type == 2 ? ('/page/article_list/' + item.id ) : '/'"
                exact
              >
                {{item.title}}
                <!-- <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span> -->
                <i class="underline"></i>
              </router-link>
              <dl v-if="item.children && item.children.length>0">
                <template v-for="(i,n) in item.children">
                  <dt
                    v-if="i.title"
                    style="padding: 0;"
                  >
                    <!-- <a style="color: #FFFFFF;">{{i.title}}</a> -->
                    <router-link
                      :to=" i.type == 1 ? ('/page/singlepage/' + i.id ): i.type == 'home' ? '/' : i.type == 4 ? i.url : i.type == 2 ? ('/page/article_list/' + i.id ) : '/'"
                      exact
                    >
                      <div style="color: #FFFFFF;padding: 10px;font-size: 14px;white-space: nowrap;">{{i.title}} </div>
                      <!-- <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span> -->
                      <!-- <i class="underline"></i> -->
                    </router-link>
                  </dt>
                </template>
              </dl>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img
          v-if="$store.state.languageVuex == 'en'"
          class="center-block"
          src="@/assets/img/gbLogoEN.png"
          alt="logo"
        >
        <img
          v-else
          class="center-block"
          src="@/assets/img/gbLogo.png"
          alt="logo"
        >
      </div>
      <div style="padding: 4px;position: relative;">
        <input
          type="text"
          v-model="ratingCode"
          @keydown.enter="handleSearch"
          :placeholder="$t('message.i18n_2')"
          style="border: 1px solid #ebebeb;width: 100%;height: 33px;border-radius: 33px;padding-left: 10px;"
        >
        <span
          style="color: #000000;position: absolute;right: 20px;top: 10px;color: #cc0000;"
          @click="handleSearch"
        >{{ $t("message.i18n_1") }}</span>
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu">
        <span style="margin-left: 20px;">{{ $t("message.i18n_89") }}</span>
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
          style="margin-right: 20px;padding-left: 15px;"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul
          id="menu"
          class="header-nav-m-wrapper collapse"
        >
          <template v-for="(item,index) in menuList">
            <li
              v-if="item.title"
              :class="index==navIndex?'active':''"
              @click="navClick(index,item.title)"
              data-toggle="collapse"
              style="margin-right: 2px;position: relative;font-size: 18px;"
            >
              <router-link
                :to=" item.type == 1 ? ('/page/singlepage/' + item.id ): item.type == 'home' ? '/' : item.type == 4 ? item.url : '/'"
                exact
              >
                <span
                  @click="closeCollapse()"
                  style="font-size: 18px;"
                >{{item.title}} </span>
                <!-- <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span> -->
                <i class="underline"></i>
              </router-link>
              <span
                :data-target="'#collapseOne' + index"
                data-toggle="collapse"
                v-if="item.children && item.children.length > 0"
                class="glyphicon glyphicon-menu-down"
                style="
								position: absolute;
								right: 30px;
								top: 10px;
								font-size: 10px;
								width: 30px;
								height: 35px;
								padding-left: 10px;
								padding-top: 10px;"
              ></span>
              <dl
                class="collapse"
                :id="'collapseOne' + index"
                data-parent
                v-if="item.children && item.children.length>0"
                style="color: #000000;"
              >
                <template v-for="(i,n) in item.children">
                  <dt
                    v-if="i.title"
                    style="padding: 0;"
                  >
                    <!-- <a style="color: #FFFFFF;">{{i.title}}</a> -->
                    <router-link
                      :to=" i.type == 1 ? ('/page/singlepage/' + i.id ): i.type == 'home' ? '/' : i.type == 4 ? i.url: '/'"
                      exact
                    >
                      <div
                        style="color: #fff;padding: 10px;font-size: 14px;"
                        @click="closeCollapse()"
                      >{{i.title}} </div>
                      <!-- <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span> -->
                      <!-- <i class="underline"></i> -->
                    </router-link>
                  </dt>
                </template>
              </dl>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import {
  GetMenuList
} from '../api/api.js'
export default {
  name: "Header",
  data () {
    return {
      language: localStorage.getItem('language') || navigator.language || 'zh-CN',
      ratingCode: undefined,
      menuList: [],			// 顶部导航标题
      pcWrapperFix: false, // pc导航条顶部固定
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuClass: "glyphicon glyphicon-menu-down",
      mainServer: false
    };
  },
  watch: {
    language (newVal) {
      window.location.reload()
      localStorage.setItem('language', newVal)
      this.$store.state.languageVuex = newVal
    }
  },
  mounted () {
    this.$bus.$on('mainServer', (e) => {
      // 首页主营服务点击，写死顶部选择评级标准标题
      if (e) {
        for (let i = 0; i < this.menuList.length; i++) {
          if (this.menuList[i].title == '评级标准') {
            this.navIndex = i
            sessionStorage.setItem('navIndex', this.navIndex)
            break
          }
        }
      }
    });
    // console.log(navigator.language,'navigator.language')
    // console.log(this.$route.name,'***')
    this.getMenuList()
    window.addEventListener("scroll", this.handleScroll)
  },
  methods: {
    closeCollapse () {
      // console.log('关闭折叠')
      $(".collapse").collapse('hide')
    },
    handleSearch () {
      this.$router.push({ name: 'search', query: { k: this.ratingCode } })
      this.ratingCode = undefined
    },
    flushCom () {
      this.$router.go(0)
    },
    routerTo (item) {
      // 1 单页   2文章列表   3图片列表   4表格   home首页
      if (item.type == 'home') {
        this.$router.push({
          path: '/',
        })
        return
      }
      if (item.type == 1) {
        this.$router.push({
          path: '/page/singlepage/' + item.id,
        })
      } else if (item.type == 2) {

      } else if (item.type == 3) {

      } else if (item.type == 4) {

      }
    },
    getMenuList () {
      GetMenuList().then(res => {
        if (res && res.errorCode == 0) {
          if (this.$store.state.languageVuex == 'en') {
            let objEnglish = JSON.stringify(res.data).replace(/"title"/g, "\"zh-CN\"").replace(/"titleEnglish"/g, "\"title\"");
            this.menuList = JSON.parse(objEnglish);
          } else {
            this.menuList = res.data
          }
          this.menuList.forEach(item => {
            if (item.url == '/page/overseasAgency') {
              item.type = 4
            }
          })
          console.log(this.menuList, 'this.menuList')
          this.menuList.unshift(
            {
              title: this.$store.state.languageVuex == 'en' ? 'HOME' : '首页',
              path: '/',
              type: 'home'
            }
          )
        } else {

        }
      })
    },
    handleScroll () {
      if (document.documentElement.scrollTop > 162) {
        this.pcWrapperFix = true
      } else {
        this.pcWrapperFix = false
      }
    },
    navClick (index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index)
    },
    menuClick () {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
	.topSearchInputBox {
		margin-left: 350px;
		position: relative;
	}

	.topSearchInputBox .input {
		width: 200px;
		height: 34px;
		border: 2px solid rgb(204, 0, 0);
	}

	.topSearchInputBox .tip {
		font-size: 15px;
		color: rgb(204, 0, 0);
		position: absolute;
		top: 1px;
		right: 5px;
		cursor: pointer;
	}

	.serveTelBox {
		margin-top: -23px;
		margin-left: 80px;
		line-height: 24px;
	}

	.serveTelBox .top {
		color: #666;
		font-weight: bold;
	}

	.serveTelBox .bot {
		color: #D61E36;
		font-size: 25px;
		font-weight: bold;
	}

	/* 顶部 */
	#header {
		background: #e22634;
		transition: all ease 0.6s;
	}

	#header .header-top {
		height: 100px;
		color: #fff;
		font-size: 12px;
		line-height: 50px;
		background-image: url(../assets/img/topbg1.jpg);
		background-position: -180px 0px;
	}

	/* 顶部的图标 */
	#header .header-top span {
		margin: 0 8px;
	}

	/* 导航栏 */
	#header .header-nav {
		height: 60px;
	}

	/* 导航栏 导航容器 */
	#header .header-nav-fixed .header-nav-wrapper {
		line-height: 50px;
	}

	#header .header-nav .header-nav-wrapper {
		line-height: 30px;
		float: left;
		margin: 0;
		max-width: 1100px;
	}

	/* 导航栏 每个导航 */
	#header .header-nav .header-nav-wrapper>li {
		float: left;
		/* margin: 0 15px; */
		position: relative;

	}

	/* 导航栏 每个导航下面的 a 链接 */
	#header .header-nav .header-nav-wrapper>li>a {
		display: block;
		/* width: 100px; */
		text-align: center;
		color: #FFFFFF;
		font-size: 16;
		padding: 15px 20px;
		position: relative;
	}

	/* 导航栏 每个导航下面的 a 链接的下划线 */
	#header .header-nav .header-nav-wrapper>li>a>i {
		display: block;
		position: absolute;
		bottom: -2px;
		left: 50%;
		width: 100px;
		height: 60px;
		opacity: 0;
	}

	/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
	#header .header-nav .header-nav-wrapper>li>a>span {
		font-size: 12px;
		transition: transform ease 0.5s;
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
	#header .header-nav .header-nav-wrapper>li>a:hover {
		color: #FFFFFF;
		text-decoration: none;
		background-color: rgb(176,18,28);
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
	#header .header-nav .header-nav-wrapper>li>a:hover .underline {
		opacity: 0.5;
		width: 100%;
		left: 0;
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
	#header .header-nav .header-nav-wrapper>li>a:hover span {
		transform: rotate(180deg);
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
	#header .header-nav .header-nav-wrapper>li.active>a {
		color: #FFFFFF;
		text-decoration: none;
		background-color: rgb(176,18,28);
		/* opacity: 0.5; */
		/* border-bottom: 2px solid #512485; */
	}

	/* 导航栏 每个导航下面的二级导航容器 */
	#header .header-nav .header-nav-wrapper>li>dl {
		display: none;
		position: absolute;
		min-width: 168px;
		top: 100%;
		left: 0;
		z-index: 999999;
		/* box-shadow: 0 0 3px 1px #ccc; */
		background: rgb(176,18,28);
	}

	/* 导航栏 每个导航下面的二级导航容器的每个导航 */
	#header .header-nav .header-nav-wrapper>li>dl>dt {
		width: 100%;
		padding: 10px;
		/* border-bottom: 1px solid #ccc; */
	}

	/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
	#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
		text-decoration: none;
	}

	/* 导航栏 滑上一级导航显示二级导航 */
	#header .header-nav .header-nav-wrapper>li:hover dl {
		display: block;
	}

	#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
		cursor: pointer;
		background: #E22434;
	}

	@media screen and (max-width: 997px) {
		#header .header-nav-m {
			position: relative;
		}

		/* 导航栏logo容器 */
		#header .header-nav-m .header-nav-m-logo {
			height: 100px;
			position: relative;
			background-image: url(../assets/img/topbg1.jpg);
			background-position: -1380px 300px;
		}

		/* 导航栏logo图片 */
		#header .header-nav-m .header-nav-m-logo img {
			/* width: 300px; */
			/* height: 50px; */
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			margin: auto;
		}

		/* 导航栏  菜单容器 */
		#header .header-nav-m .header-nav-m-menu {
			color: #FFFFFF;
			height: 50px;
			font-size: 20px;
			line-height: 50px;
			background: #E22434;
			position: relative;
		}

		/* 导航栏 菜单图标 */
		#header .header-nav-m .header-nav-m-menu-wrapper {
			position: absolute;
			top: 45%;
			right: 0px;
			margin-top: -20px;
			width: 50px;
			height: 40px;
			color: #fff;
			z-index: 999999;
			font-size: 12px;
		}

		/* 导航栏 */
		#header .header-nav-m .header-nav-m-wrapper {
			position: absolute;
			top: 50px;
			left: 0;
			width: 100%;
			background: #E22434;
			z-index: 9999999;
			padding-left: 20px;
		}
		/* 导航栏 每个导航 */
		#header .header-nav-m .header-nav-m-wrapper>li {
			/* height: 40px; */
			/* line-height: 40px; */
			/* border-bottom: 1px solid #ccc; */
		}

		/* 导航栏 每个导航下面的 a 链接 */
		#header .header-nav-m .header-nav-m-wrapper>li>a {
			color: #fff;
			font-size: 15px;
			font-weight: bold;
			padding: 15px 0;
			position: relative;
		}

		/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
		#header .header-nav .header-nav-wrapper>li>a>span {
			font-size: 10px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue